import { render, staticRenderFns } from "./table-5_7.vue?vue&type=template&id=47ccdf7a&scoped=true&"
import script from "./table-5_7.vue?vue&type=script&lang=js&"
export * from "./table-5_7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ccdf7a",
  null
  
)

export default component.exports